<div *ngIf="privilegesView==='AccessDenied'" class=" outside-container  mt-4" >
  <div class="box-container">
    <div class="container">
      <div *ngIf="privilegesView==='AccessDenied'" class="  d-flex justify-content-center" >

  <img src="../../../assets/images/AccessDeniedError.png" alt="">
</div>

 </div>
</div>
</div>

<div *ngIf="privilegesView==='VAMD'" class="outside-container mt-4">
    <div class="box-container ">
        <div class="container">
            <div class="title ">

              <div class="row">
                <div class=" col-md-2  " ><div class="pointer d-flex justify-content-start "  (click)="backClick()" style="padding-left:20px;">⬅️</div></div>  
               <div class="col-md-7 d-flex justify-content-center">Air Management</div>
               <div class=" col-md-3 row ">
                 <div class="d-flex justify-content-end">
                  <button *ngIf="showGroup" class="btn btn-outline-primary btn-sm " (click)="onAddGroup()"><img src="assets/images/Add_24.png"></button>
                  <button *ngIf="showSupplier" class="btn btn-outline-primary btn-sm " (click)="onAddSupplier()"><img src="assets/images/Add_24.png"></button>
                  <button  *ngIf="showSource" class="btn btn-outline-primary btn-sm " (click)="onAddSource()"><img src="assets/images/Add_24.png"></button>
                  <button  *ngIf="showCarrier" class="btn btn-outline-primary btn-sm " (click)="onAddCarrier()"><img src="assets/images/Add_24.png"></button>

               </div>
                </div>
              </div>
            
            </div> 
            </div>
            </div>
          </div>
          <div *ngIf="privilegesView==='VAMD'" class="outside-container ">
            <div class="box-container ">
                <div class="container ">
                  <div class="col-md-12 row d-flex justify-content-center " style="padding-left: 20px; ">
                 
                 
                    <div class="col-md-2  " [ngStyle]="{'background-color':color?.sideBarColor}"  style="border-radius: 4px; content: right; padding-top: 10px; height:70vh;overflow-y: auto; ">
                      <div class="col-md-12 ">
                      <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"  (click)="onClickGroup()"     [ngClass]="{'activity' :showGroup}">Group</span></span>
                      <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"  (click)="onClickSupplier()"  [ngClass]="{'activity' :showSupplier}">Supplier</span></span>
                      <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"  (click)="onClickSource()"     [ngClass]="{'activity' :showSource}">Sources</span></span> 
                      <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"  (click)="onClickCarrier()"     [ngClass]="{'activity' :showCarrier}">Carrier</span></span> 
                      <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"  (click)="onClickCommission()"     [ngClass]="{'activity' :showCommission}">IATA Commission</span></span> 
                      <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"  (click)="onClickMeals()"     [ngClass]="{'activity' :showMeals}">Meals/SSR</span></span> 
                      <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"  (click)="onClickMiles()"     [ngClass]="{'activity' :showMiles}">Miles</span></span> 
                      <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"  (click)="onClickAirports()"     [ngClass]="{'activity' :showAirport}">Airport</span></span> 
                      <span class=" d-flex justify-content-center mb-4 mb-2" style=" height: 22px"> <span class=" btns"  (click)="onClickBranch()"     [ngClass]="{'activity' :showBranchId}">Branch</span></span> 

                    </div>
                      
                    </div>

                   <div class="col-md-10" style="height:70vh; overflow-y: auto;">
                     <div *ngIf="showGroup" class="col-md-12 card" style="min-height: 100%;" >

                      <div class=" row mt-3 " style="padding: 10px;">
                       
                        
                        <div class="col-md-12 " >
                          <div class="row">
                          <mat-form-field class=" col-md-3 mt-1 form-group " >
                          <input matInput type="text"  [(ngModel)]="search.searchText"    placeholder="Search..." autocomplete="off" (input)="searchUser()"  >
                          
                          </mat-form-field>
                          <mat-paginator  class="col-md-9 mt-2 " style="background-color: transparent;" color="primary"
                          [pageSize]="10"
                          [pageSizeOptions]="[5, 10, 25, 100]"
                          [length]="totalElements"
                          (page)="nextPage($event)"
                          aria-label="Select page">
                          </mat-paginator>
                          
                          </div>
                          
                          <table mat-table
                          [dataSource]="groupData" multiTemplateDataRows style="background-color: transparent;">
                         
                          <!-- <ng-container matColumnDef="code">
                           <th mat-header-cell *matHeaderCellDef> Code </th>
                           <td mat-cell *matCellDef="let element;"> {{element.code}} </td>
                          </ng-container> -->
                           <ng-container matColumnDef="name">
                             <th mat-header-cell *matHeaderCellDef>Name</th>
                             <td mat-cell *matCellDef="let element" style="padding: 4px; cursor: pointer; color: rgb(24,118,209);" (click)="rowGroupClick(element)"> {{element.name}} </td>
                           </ng-container>

                          <ng-container matColumnDef="status">
                           <th mat-header-cell *matHeaderCellDef> Status </th>
                           <td mat-cell *matCellDef="let element"> 
                            <span *ngIf="element.status==='A'">Active</span>
                            <span *ngIf="element.status==='I'">Inactive</span> </td>
                          </ng-container>
                          
                          <!-- email Column -->
                         
                          <ng-container matColumnDef="creationDate" >
                            <th mat-header-cell *matHeaderCellDef>Creation Date</th>
                            <td mat-cell *matCellDef="let element"> {{formatDate(element.genTs)}} </td>
                           </ng-container>
                         
                          <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                          <ng-container matColumnDef="expandedDetail">
                          <td mat-cell *matCellDef="let element" [attr.colspan]="columnsGroupDisplay.length">
                          <div class="example-element-detail row"
                           [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                          
                          </div>
                          </td>
                          </ng-container>
                          
                          <tr mat-header-row *matHeaderRowDef="columnsGroupDisplay"></tr>
                          <tr mat-row *matRowDef="let element; columns: columnsGroupDisplay;"
                          class="example-element-row">
                          </tr>
                          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                          <tr class="mat-row" *matNoDataRow>
                          <td  class="mat-cell" colspan="4">There is no data in this table</td>
                          </tr>
                          </table>
                          
                          
                          </div>
                          
                      
                    
                    </div> 
                      </div>
                      <div *ngIf="showSupplier" class="col-md-12 card" style="min-height: 100%;" >
                      
                        <div class=" row mt-3 " style="padding: 10px;">
                       
                        
                          <div class="col-md-12 " >
                            <div class="row">
                            <mat-form-field class=" col-md-3 mt-1 form-group " >
                              <input matInput type="text"  [(ngModel)]="supplierSearch.searchText"  placeholder="Search..." autocomplete="off" (input)="searchSupplier()"  >
                            
                            </mat-form-field>
                            <mat-paginator  class="col-md-9 mt-2 " style="background-color: transparent;" color="primary"
                            [pageSize]="10"
                            [pageSizeOptions]="[5, 10, 25, 100]"
                            [length]="totalElements"
                            (page)="nextSupplierPage($event)"
                            aria-label="Select page">
                            </mat-paginator>
                            
                            </div>
                            
                            <table mat-table
                            [dataSource]="supplierData" multiTemplateDataRows style="background-color: transparent;">
                           
                            <!-- <ng-container matColumnDef="code">
                             <th mat-header-cell *matHeaderCellDef> Code </th>
                             <td mat-cell *matCellDef="let element;"> {{ element.code}} </td>
                            </ng-container> -->
                             <ng-container matColumnDef="name">
                               <th mat-header-cell *matHeaderCellDef>Name</th>
                               <td mat-cell *matCellDef="let element" style="padding: 4px; cursor: pointer; color: rgb(24,118,209);" (click)="rowSupplierClick(element)"> {{element.name}} </td>
                             </ng-container>
                             <!-- <ng-container matColumnDef="groupCode">
                              <th mat-header-cell *matHeaderCellDef>Group Code</th>
                              <td mat-cell *matCellDef="let element"> {{element.groupCode}} </td>
                            </ng-container>          -->
                                               <ng-container matColumnDef="status">
                             <th mat-header-cell *matHeaderCellDef> Status </th>
                             <td mat-cell *matCellDef="let element"> 
                              <span *ngIf="element.status==='A'">Active</span>
                              <span *ngIf="element.status==='I'">Inactive</span> </td>
                            </ng-container>
                            
                            <!-- email Column -->
                           
                            <ng-container matColumnDef="creationDate">
                              <th mat-header-cell *matHeaderCellDef>Creation Date </th>
                              <td mat-cell *matCellDef="let element"> {{formatDate(element.genTs)}} </td>
                             </ng-container>
                           
                            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                            <ng-container matColumnDef="expandedDetail">
                            <td mat-cell *matCellDef="let element" [attr.colspan]="columnsSupplierDisplay.length">
                            <div class="example-element-detail row"
                             [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                            
                            </div>
                            </td>
                            </ng-container>
                            
                            <tr mat-header-row *matHeaderRowDef="columnsSupplierDisplay"></tr>
                            <tr mat-row *matRowDef="let element; columns: columnsSupplierDisplay;"
                            class="example-element-row">
                            </tr>
                            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                            <tr class="mat-row" *matNoDataRow>
                            <td  class="mat-cell" colspan="4">There is no data in this table</td>
                            </tr>
                            </table>
                            
                            
                            </div>
                            
                        
                      
                      </div> 
                      </div>
                      <div *ngIf="showSource" class="col-md-12 card" style="min-height: 100%;" >
                      
                        <div class=" row mt-3 " style="padding: 10px;">
                       
                        
                          <div class="col-md-12 " >
                            <div class="row">
                            <mat-form-field class=" col-md-3 mt-1 form-group " >
                              <input matInput type="text"  [(ngModel)]="sourceSearch.searchText"    placeholder="Search..." autocomplete="off" (input)="searchSource()"  >
                            
                            </mat-form-field>
                            <mat-paginator  class="col-md-9 mt-2 " style="background-color: transparent;" color="primary"
                            [pageSize]="10"
                            [pageSizeOptions]="[5, 10, 25, 100]"
                            [length]="totalElements"
                            (page)="nextSourcePage($event)"
                            aria-label="Select page">
                            </mat-paginator>
                            
                            </div>
                            
                            <table mat-table
                            [dataSource]="sourceData" multiTemplateDataRows style="background-color: transparent;">
                           
                            <!-- <ng-container matColumnDef="code">
                             <th mat-header-cell *matHeaderCellDef> Code </th>
                             <td mat-cell *matCellDef="let element;"> {{element.code}} </td>
                            </ng-container> -->
                             <ng-container matColumnDef="name">
                               <th mat-header-cell *matHeaderCellDef>Name</th>
                               <td mat-cell *matCellDef="let element" style="padding: 4px; cursor: pointer; color: rgb(24,118,209);" (click)="rowSourceClick(element)"> {{element.name}} </td>
                             </ng-container>
                             <ng-container matColumnDef="type">
                              <th mat-header-cell *matHeaderCellDef> Type </th>
                              <td mat-cell *matCellDef="let element"> {{element.type}} </td>
                             </ng-container>
                             <ng-container matColumnDef="supplierCode">
                              <th mat-header-cell *matHeaderCellDef>Supplier </th>
                              <td mat-cell *matCellDef="let element" style="padding: 4px;"> 
                                {{element.supplierCode}} 
                              </td>
                             </ng-container>
                            <ng-container matColumnDef="status">
                             <th mat-header-cell *matHeaderCellDef> Status </th>
                             <td mat-cell *matCellDef="let element" > 
                              <span *ngIf="element.status==='A'">Active</span>
                              <span *ngIf="element.status==='I'">Inactive</span>
                            </td>
                            </ng-container>
                            
                            <!-- <ng-container matColumnDef="groupCode">
                              <th mat-header-cell *matHeaderCellDef> Group Code </th>
                              <td mat-cell *matCellDef="let element;"> {{ element.groupCode}} </td>
                             </ng-container>
                             <ng-container matColumnDef="supplierCode">
                              <th mat-header-cell *matHeaderCellDef> Supplier Code </th>
                              <td mat-cell *matCellDef="let element;"> {{element.supplierCode}} </td>
                             </ng-container> -->
                           
                            <ng-container matColumnDef="creationDate">
                              <th mat-header-cell *matHeaderCellDef>Creation Date </th>
                              <td mat-cell *matCellDef="let element"> {{formatDate(element.genTs)}} </td>
                             </ng-container>
                           
                            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                            <ng-container matColumnDef="expandedDetail">
                            <td mat-cell *matCellDef="let element" [attr.colspan]="columnsSourceDisplay.length">
                            <div class="example-element-detail row"
                             [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                            
                            </div>
                            </td>
                            </ng-container>
                            
                            <tr mat-header-row *matHeaderRowDef="columnsSourceDisplay"></tr>
                            <tr mat-row *matRowDef="let element; columns: columnsSourceDisplay;"
                            class="example-element-row">
                            </tr>
                            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                            <tr class="mat-row" *matNoDataRow>
                            <td  class="mat-cell" colspan="4">There is no data in this table</td>
                            </tr>
                            </table>
                            
                            
                            </div>
                            
                        
                      
                      </div> 
                      </div>

                      <div *ngIf="showCarrier" class="col-md-12 card" style="min-height: 100%;" >

                        <div class=" row mt-3 " style="padding: 10px;">
                         
                          
                          <div class="col-md-12 " >
                            <div class="row">
                            <mat-form-field class=" col-md-3 mt-1 form-group " >
                            <input matInput type="text"  [(ngModel)]="search.searchText"    placeholder="Search..." autocomplete="off" (input)="searchCarrier()"  >
                            
                            </mat-form-field>
                            <mat-paginator  class="col-md-9 mt-2 " style="background-color: transparent;" color="primary"
                            [pageSize]="10"
                            [pageSizeOptions]="[5, 10, 25, 100]"
                            [length]="totalElements"
                            (page)="nextCarrierPage($event)"
                            aria-label="Select page">
                            </mat-paginator>
                            
                            </div>
                            
                            <table mat-table
                            [dataSource]="carrierData" multiTemplateDataRows style="background-color: transparent;">
                           
                            <!-- <ng-container matColumnDef="accountingCode">
                             <th mat-header-cell *matHeaderCellDef> Accounting Code </th>
                             <td mat-cell *matCellDef="let element;"> {{element.airlineAccountingCode}} </td>
                            </ng-container>
                            <ng-container matColumnDef="designatorCode">
                              <th mat-header-cell *matHeaderCellDef> Designator Code </th>
                              <td mat-cell *matCellDef="let element;"> {{element.airlineDesignatorCode}} </td>
                             </ng-container> -->
                             <ng-container matColumnDef="name">
                               <th mat-header-cell *matHeaderCellDef>Name</th>
                               <td mat-cell *matCellDef="let element" style="padding: 4px; cursor: pointer; color: rgb(24,118,209);" (click)="rowCarrierClick(element)"> {{element.carrierName}} </td>
                             </ng-container>
                            <ng-container matColumnDef="status">
                             <th mat-header-cell *matHeaderCellDef> Status </th>
                             <td mat-cell *matCellDef="let element"> 
                              <span *ngIf="element.status==='A'">Active</span>
                              <span *ngIf="element.status==='I'">Inactive</span> </td>
                            </ng-container>
                            <ng-container matColumnDef="helpline">
                              <th mat-header-cell *matHeaderCellDef>Helpline No</th>
                              <td mat-cell *matCellDef="let element"  > {{element.helplineNo}} </td>
                            </ng-container>
                            
                           
                            <ng-container matColumnDef="creationDate">
                              <th mat-header-cell *matHeaderCellDef>Creation Date</th>
                              <td mat-cell *matCellDef="let element"> {{formatDate(element.genTs)}} </td>
                             </ng-container>
                             <ng-container matColumnDef="blank">
                              <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
                              <td mat-cell *matCellDef="let element">
                                 <button style="background-color: #3389fa;color: white;margin: 4px; " mat-flat-button (click)="onClickGST(element.airlineDesignatorCode,'gstDetail')">GST Detail</button>
                                 <button style="background-color: #3389fa;color: white;margin: 4px; " mat-flat-button (click)="onClickMapping(element.airlineDesignatorCode,'mapping')">Mapping</button>

                              </td>
                             </ng-container>
                           
                            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                            <ng-container matColumnDef="expandedDetail">
                            <td mat-cell *matCellDef="let element" [attr.colspan]="columnsCarrierDisplay.length">
                            <div class="example-element-detail row"
                             [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                            
                            </div>
                            </td>
                            </ng-container>
                            
                            <tr mat-header-row *matHeaderRowDef="columnsCarrierDisplay"></tr>
                            <tr mat-row *matRowDef="let element; columns: columnsCarrierDisplay;"
                            class="example-element-row">
                            </tr>
                            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                            <tr class="mat-row" *matNoDataRow>
                            <td  class="mat-cell" colspan="4">There is no data in this table</td>
                            </tr>
                            </table>
                            
                            
                            </div>
                            
                        
                      
                      </div> 
                        </div>

                        <div *ngIf="showCommission" class="col-md-12 card" style="min-height: 100%;" >
                       <app-iata-commission></app-iata-commission>
                        </div>
                        <div *ngIf="showMeals" class="col-md-12 card" style="min-height: 100%;" >
                          <app-meals></app-meals>
                           </div>
                           <div *ngIf="showMiles" class="col-md-12 card" style="min-height: 100%;" >
                            <app-miles></app-miles>
                             </div>
                             <div *ngIf="showAirport" class="col-md-12 card" style="min-height: 100%;" >
                              <app-airports></app-airports>
                               </div>
                               <div *ngIf="showBranchId" class="col-md-12 card" style="min-height: 100%;" >
                                <app-branch></app-branch>
                                 </div>
                    </div>
                    </div>
                </div>

                <div class="modal " id="myMod"  [style.display]="showGroupPopup ? 'block' : 'none'" >
                  <div class="modal-dialog" >
                      <div class="modal-content " >
                          <div class="modal-header title">
                            <h4 class="modal-title">Add Group</h4>
                            <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
                            </div>
                            <div class="modal-body">
                            <div class="col-md-12 mt-3 " *ngIf="showGroupPopup">
                              <div class="col-md-12 d-flex justify-content-center" >
                              <div class="col-md-12 row " >
                                  <div class=" col-md-12 ">
                                      <form [formGroup]="GroupRegFg"  (ngSubmit)="AddGroup()" autocomplete="off"  class=" row" >
                                        <mat-form-field class="col-md-12" appearance="outline">
                                          <mat-label>Group Code</mat-label>
                                          <input matInput type="text" name="code" formControlName="code" autocomplete="off">
                                          <small *ngIf="GroupRegFg.controls['code'].dirty && GroupRegFg.controls['code'].invalid" class="warn " >Please Enter Group Code!</small>

                                        </mat-form-field>
                                        <mat-form-field class="col-md-12" appearance="outline">
                                          <mat-label>Group Name</mat-label>
                                          <input matInput type="text" formControlName="name" name="groupName" autocomplete="off">
                                          <small *ngIf="GroupRegFg.controls['name'].dirty && GroupRegFg.controls['name'].invalid" class="warn">Please Enter Group name!</small>

                                        </mat-form-field>
                                        
                                        <mat-form-field class="col-md-12" appearance="outline">
                                          <mat-label>Status</mat-label>
                                          <mat-select matNativeControl name="status" formControlName="status">
                                            <mat-option value="A">Active</mat-option>
                                            <mat-option value="I">Inactive</mat-option>
                                          </mat-select>  
                                        </mat-form-field>                                        
                                        </form>
                                  </div>
                                  </div>
                                  </div>                                      
                            </div>
                              <div class="modal-footer">
                                <div class="form-group form-inline ">
                                  <label for="userName" class="col-md-5 col-form-label control-label"> </label>
                                </div>   
                                <button *ngIf="action==='newGrp'" class="btn btn-outline-success c-width-100px shadow "  (click)="AddGroup()" [disabled]="GroupRegFg.invalid">Save</button>
                                <button type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                              </div>
                            </div>
                            </div>
                    </div>
                </div>
                <div class="modal" id="myMod" [style.display]="showSupplierPopup ? 'block' : 'none'" >
                  <div class="modal-dialog" >
                      <div class="modal-content " >
                          <div class="modal-header title">
                            <h4 class="modal-title">Add Supplier</h4>
                            <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
                            </div>
                            <div class="modal-body">
                            <div class="col-md-12 mt-3 " *ngIf="showSupplierPopup">
                              <div class="col-md-12 d-flex justify-content-center" >
                              <div class="col-md-12 row " >
                                  <div class=" col-md-12 ">
                                      <form  [formGroup]="SupplierRegFg" (ngSubmit)="AddSupplier()" autocomplete="off"  class=" row" >
                                        <mat-form-field class="col-md-12" appearance="outline" >
                                          <mat-label>Group Code</mat-label>
                                          <mat-select matNativeControl name="groupcode"  formControlName="groupCode">
                                            <mat-option *ngFor="let item of groupList" [value]='item.code'>{{item.name}}</mat-option>

                                          </mat-select>                                 
                                          <small *ngIf="SupplierRegFg.controls['groupCode'].dirty && SupplierRegFg.controls['groupCode'].invalid" class="warn">Please Select Group Code!</small>

                                         </mat-form-field>
                                         <mat-form-field class="col-md-12" appearance="outline">
                                          <mat-label>Supplier Code</mat-label>
                                          
                                          <input matInput type="text" name="supplierCode" formControlName="code" autocomplete="off">
                                          <small *ngIf="SupplierRegFg.controls['groupCode'].dirty && SupplierRegFg.controls['groupCode'].invalid" class="warn">Please Enter Supplier Code!</small>

                                        </mat-form-field>
                                        <mat-form-field class="col-md-12" appearance="outline">
                                          <mat-label>Supplier Name</mat-label>
                                          <input matInput type="text" name="supplierName" formControlName="name" autocomplete="off">
                                          <small *ngIf="SupplierRegFg.controls['name'].dirty && SupplierRegFg.controls['name'].invalid" class="warn">Please Enter Supplier Name!</small>

                                        </mat-form-field>
                                        <mat-form-field class="col-md-12" appearance="outline">
                                          <mat-label>Accounts Code</mat-label>
                                          <input matInput type="text" name="accountCode" formControlName="accountsCode"  autocomplete="off">
                                          <!-- <small *ngIf="SupplierRegFg.controls['name'].dirty && SupplierRegFg.controls['name'].invalid" class="warn">Please Enter Supplier Name!</small> -->

                                        </mat-form-field>
                                        
                                        <mat-form-field class="col-md-12" appearance="outline">
                                          <mat-label>Status</mat-label>
                                          <mat-select matNativeControl name="status" formControlName="status" >
                                            <mat-option value="A">Active</mat-option>
                                            <mat-option value="I">Inactive</mat-option>
                                          </mat-select>  
                                        </mat-form-field>    
                                                                             
                                        </form>                               
                                  </div>
                                  </div>
                                  </div>                                      
                            </div>
                              <div class="modal-footer">
                                <div class="form-group form-inline ">
                                  <label for="userName" class="col-md-5 col-form-label control-label"> </label>
                                </div>   
                                <button *ngIf="action==='newSupplier'" class="btn btn-outline-success c-width-100px shadow " (click)="AddSupplier()" [disabled]="SupplierRegFg.invalid" >Save</button>
                                <button type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                              </div>
                            </div>
                            </div>
                    </div>
                </div>
                <div class="modal" id="myMod" [style.display]="showSourcePopup ? 'block' : 'none'" >
                  <div class="modal-dialog" >
                      <div class="modal-content " >
                          <div class="modal-header title">
                            <h4 *ngIf="action==='newSource'" class="modal-title">Add Source Rout</h4>
                            <h4 *ngIf="action!='newSource'" class="modal-title">View Source Rout</h4>

                            <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
                            </div>
                            <div class="modal-body">
                            <div class="col-md-12 mt-3 " *ngIf="showSourcePopup">
                              <div class="col-md-12 d-flex justify-content-center" >
                              <div class="col-md-12 row " >
                                  <div class=" col-md-12 ">
                                      <form  [formGroup]="SourceRegFg" (ngSubmit)="AddSource()" autocomplete="off"  class=" row" >
                                        <mat-form-field class="col-md-12" appearance="outline">
                                          <mat-label>Group Code</mat-label>
                                          <mat-select matNativeControl name="Gcode" formControlName="groupCode" >
                                            <mat-option *ngFor="let item of groupList" [value]='item.code'>{{item.name}}</mat-option>

                                          </mat-select>                       
                                          <small *ngIf="SourceRegFg.controls['groupCode'].dirty && SourceRegFg.controls['groupCode'].invalid" class="warn">Please Select Group Code!</small>
          
                                         </mat-form-field>
                                         <mat-form-field class="col-md-12" appearance="outline">
                                          <mat-label> From Source </mat-label>
                                          <mat-select matNativeControl name="sourceCode" formControlName="code" (selectionChange)="onSourceSelect($event)">
                                            <mat-option *ngFor="let item of sourceCodeList" [value]='item.code'>{{item.title}}</mat-option>
                                            
                                          </mat-select>   
                                          <small *ngIf="SourceRegFg.controls['code'].dirty && SourceRegFg.controls['code'].invalid" class="warn">Please Enter Source Code!</small>

                                        </mat-form-field>
                                        <mat-form-field class="col-md-12" appearance="outline">
                                          <mat-label>Via Supplier</mat-label>
                                          <mat-select matNativeControl name="scode" formControlName="supplierCode" >
                                            <mat-option *ngFor="let item of supplierList" [value]='item.code'>{{item.name}}</mat-option>
                                            
                                          </mat-select>                                      
                                          <small *ngIf="SourceRegFg.controls['supplierCode'].dirty && SourceRegFg.controls['supplierCode'].invalid" class="warn">Please Select Supplier Code!</small>
   
                                         </mat-form-field>
                                         
                                         <!-- <mat-form-field class="col-md-12" appearance="outline">
                                          <mat-label>Source Name</mat-label>
                                          <input matInput type="text" name="SourceName" formControlName="name" autocomplete="off">
                                          <small *ngIf="SourceRegFg.controls['name'].dirty && SourceRegFg.controls['name'].invalid" class="warn">Please Enter Source Name!</small>

                                        </mat-form-field> -->
                                        <mat-form-field class="col-md-12" appearance="outline">
                                          <mat-label>Type</mat-label>
                                          <mat-select matNativeControl name="status" formControlName="type" >
                                            <mat-option value="GDS">GDS</mat-option>
                                            <mat-option value="LCC">LCC</mat-option>
                                          </mat-select>  
                                          <small *ngIf="SourceRegFg.controls['type'].dirty && SourceRegFg.controls['type'].invalid" class="warn">Please Select Type!</small>

                                        </mat-form-field>  
                                        <mat-form-field class="col-md-12" appearance="outline">
                                          <mat-label>Status</mat-label>
                                          <mat-select matNativeControl name="status" formControlName="status">
                                            <mat-option value="A">Active</mat-option>
                                            <mat-option value="I">Inactive</mat-option>
                                          </mat-select>  
                                        </mat-form-field>                                                                           
                                        </form>
                                  </div>
                                  </div>
                                  </div>                                      
                            </div>
                              <div class="modal-footer">
                                <div class="form-group form-inline ">
                                  <label for="userName" class="col-md-5 col-form-label control-label"> </label>
                                </div>   
                                <button *ngIf="action==='newSource'" class="btn btn-outline-success c-width-100px shadow " (click)="AddSource()" [disabled]="SourceRegFg.invalid" >Save</button>
                                <button type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                              </div>
                            </div>
                            </div>
                    </div>
                </div>

                <div class="modal " id="myMod"  [style.display]="showCarrierPopup ? 'block' : 'none'" >
                  <div class="modal-dialog" >
                   


                      <div  class="modal-content " >
                          <div class="modal-header title">
                            <h4 *ngIf="action==='newCarrier'" class="modal-title">Add Carrier</h4>
                            <h4 *ngIf="action==='updateCarrier'" class="modal-title">Edit Carrier</h4>

                            <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
                            </div>
                            <div class="modal-body">
                            <div class="col-md-12 mt-3 " *ngIf="showCarrierPopup">
                              <div class="col-md-12 d-flex justify-content-center" >
                              <div class="col-md-12 row " >
                                  <div class=" col-md-12 ">
                                      <form [formGroup]="CarrierRegFg"  (ngSubmit)="AddCarrier()" autocomplete="off"  class=" row" >
                                       
                                        <mat-form-field class="col-md-12" appearance="outline">
                                          <mat-label>Airline Accounting Code</mat-label>
                                          <input matInput type="text" formControlName="airlineAccountingCode" [readonly]="action==='updateCarrier'" maxlength="3" name="AccountingCode"   autocomplete="off">
                                          <small *ngIf="CarrierRegFg.controls['airlineAccountingCode'].dirty && CarrierRegFg.controls['airlineAccountingCode'].invalid" class="warn">Please Enter Airline Accounting Code!</small>

                                        </mat-form-field>
                                        <mat-form-field class="col-md-12" appearance="outline">
                                          <mat-label>Airline Designator Code</mat-label>
                                          <input matInput type="text" formControlName="airlineDesignatorCode" [readonly]="action==='updateCarrier'" maxlength="3" name="designatorCode"   autocomplete="off">
                                          <small *ngIf="CarrierRegFg.controls['airlineDesignatorCode'].dirty && CarrierRegFg.controls['airlineDesignatorCode'].invalid" class="warn">Please Enter Airline Designator Code!</small>

                                        </mat-form-field>
                                        <mat-form-field class="col-md-12" appearance="outline">
                                          <mat-label>Carrier Name</mat-label>
                                          <input matInput type="text" formControlName="carrierName" maxlength="30" name="carrierName" autocomplete="off">
                                          <small *ngIf="CarrierRegFg.controls['carrierName'].dirty && CarrierRegFg.controls['carrierName'].invalid" class="warn">Please Enter Carrier Name!</small>

                                        </mat-form-field>
                                        <mat-form-field class="col-md-12" appearance="outline">
                                          <mat-label>Helpline Number (: Separated)</mat-label>
                                          <input matInput type="text" (keypress)="onlyNumberSpecialKey($event)" formControlName="helplineNo"  name="helplineNo" autocomplete="off">
                                          <small *ngIf="CarrierRegFg.controls['helplineNo'].dirty && CarrierRegFg.controls['helplineNo'].invalid" class="warn">Please Enter Helpline Number!</small>

                                        </mat-form-field>
                                        <mat-form-field class="col-md-12" appearance="outline">
                                          <mat-label>Status</mat-label>
                                          <mat-select matNativeControl name="status" formControlName="status">
                                            <mat-option value="A">Active</mat-option>
                                            <mat-option value="I">Inactive</mat-option>
                                          </mat-select>  
                                        </mat-form-field>    
                                           
                                        <mat-selection-list [(ngModel)]="passThrough" [ngModelOptions]="{standalone: true}" (click)="onClickPassThrough()">
                                          <mat-list-option color="primary" checkboxPosition="before" value="true" >Pass through</mat-list-option>
                                        
                                      </mat-selection-list> 
                                      <mat-form-field *ngIf="showCard" class="col-md-12" appearance="outline">
                                        <mat-label>CARD</mat-label>
                                        <mat-select   matNativeControl name="card"     >
                                          <mat-option *ngFor="let item of CreditData" [value]="item.maskedCardNumber"   >{{item.maskedCardNumber}}</mat-option>
                                        </mat-select>
                                      </mat-form-field>   
                                              </form>
                                  </div>
                                  </div>
                                  </div>                                      
                            </div>
                              <div class="modal-footer">
                                <div class="form-group form-inline ">
                                  <label for="userName" class="col-md-5 col-form-label control-label"> </label>
                                </div>   
                                <button  *ngIf="action==='updateCarrier'" class="btn btn-outline-success c-width-100px shadow "  (click)="UpdateCarrier()" [disabled]="CarrierRegFg.invalid">Update</button>

                                <button  *ngIf="action==='newCarrier'" class="btn btn-outline-success c-width-100px shadow "  (click)="AddCarrier()" [disabled]="CarrierRegFg.invalid">Save</button>
                                <button type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                              </div>
                            </div>
                            </div>
                    </div>
                </div>


                <div class="modal " id="myMod"  [style.display]="showGstPopup ? 'block' : 'none'" >
                  
                  <div class="modal-dialog" >

                    <div *ngIf="carrierAction==='mapping'" class="modal-content " >
                      <div class="modal-header title" *ngIf="showGstPopup">
                        <h4 class="modal-title">Mapping</h4>
                        <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>

                        </div>
                      <div class="col-md-12" style="padding: 8px;">
                      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" class="pb-2" style="text-align: left;">
                        <mat-tab  label="FARE">  
                          <form  class=" col-md-12 row " style="padding: 8px;" autocomplete="off">
                          <div class="col-md-4" appearance="outline">
                            <mat-label>FARE TYPE</mat-label>

                              <input class="form-control" minlength="35" type="text" [(ngModel)]="fareType.fareType"  name="fareType" [ngModelOptions]="{standalone: true}"  autocomplete="off"   >
                          </div>
                             <div class="col-md-4" appearance="outline" >
                              <mat-label>Display Fare Type</mat-label>
  
                                <input class="form-control" minlength="35" type="text"  name="displayFareType" [(ngModel)]="fareType.fareTypeDisplay" [ngModelOptions]="{standalone: true}" autocomplete="off"   >
                             </div>

                               <div class="col-md-4 pt-4" >
                                <mat-label>&nbsp;</mat-label>
                                <button  class="btn btn-outline-primary btn-sm "(click)="Addfare(fareType)" [disabled]="Disabled()">Save</button>

                               </div>
                              </form>
                             <div class="table-container">
                              <table class="styled-tables" >
                                <thead>
                                  <th class="name-type" style="padding: 8px; position: sticky;
                                  top: 0;
                                  left: 0;
                                  z-index: 2;">Fare Type</th>
                                  <th class="name-type" style="padding: 8px; position: sticky;
                                  top: 0;
                                  left: 0;
                                  z-index: 2;">Display Fare Type </th>
                                  <th class="name-type" style="padding: 8px; position: sticky;
                                  top: 0;
                                  left: 0;
                                  z-index: 2;">Action </th>

                                </thead>
                                <tbody>
                                  
                                  <tr  *ngFor="let item of fareList" >
                                    <!-- Display structured data -->
                                    <td   style="padding: 8px;"> 
          
                                        <input class="form-control" type="text" minlength="35"  name="fareType" [(ngModel)]="item.fareType" autocomplete="off"   >
                                      </td>
                                    <td   style="padding: 8px;">            
                                          <input class="form-control" type="text"  minlength="35"  name="displayFareType"  [(ngModel)]="item.fareTypeDisplay" autocomplete="off"   >
                                    </td>
                                    <td   style="padding: 8px;">
                                      <button type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="Updatefare(item)"  [disabled]="DisabledUpDATE(item)">Update</button>
                                    </td>

                                  </tr>
                                 
                                </tbody>
                              </table>
                            </div>
</mat-tab>

<!-- <mat-tab  label="Taxes">  

  <form  class=" col-md-12 row " style="padding: 8px;" autocomplete="off">
    <div class="col-md-4" appearance="outline">
      <mat-label>Foreign Tax Name</mat-label>

        <input class="form-control" minlength="35" type="text" [(ngModel)]="foreign.foreignTaxName"  name="foreignName" [ngModelOptions]="{standalone: true}"  autocomplete="off"   >
    </div>
       <div class="col-md-4" appearance="outline" >
        <mat-label>Foreign Tax Mapping</mat-label>

          <input class="form-control" minlength="35" type="text"  name="foreignTax" [(ngModel)]="foreign.foreignTaxMapping" [ngModelOptions]="{standalone: true}" autocomplete="off"   >
       </div>

         <div class="col-md-4 pt-4" >
          <mat-label>&nbsp;</mat-label>
          <button  class="btn btn-outline-primary btn-sm "(click)="AddTax(foreign)" [disabled]="DisabledTax()">Save</button>

         </div>
        </form>
        <div class="table-container">

        <table class="styled-tables" style="font-size: 15px;">
          <thead>
            <th class="name-type" style="padding: 8px;position: sticky;
            top: 0;
            left: 0;
            z-index: 2;">Foreign Tax Name</th>
            <th class="name-type" style="padding: 8px;position: sticky;
            top: 0;
            left: 0;
            z-index: 2;">Foreign Tax Mapping </th>
            <th class="name-type" style="padding: 8px;position: sticky;
            top: 0;
            left: 0;
            z-index: 2;">Action </th>

          </thead>
          <tbody>
            
            <tr  *ngFor="let item of ForeignList" style="overflow: auto;max-height: 30vh;">
              <td   style="padding: 8px;"> 

                  <input class="form-control" type="text" minlength="35"  name="foreignTaxName" [(ngModel)]="item.foreignTaxName" autocomplete="off"   >
                </td>
              <td   style="padding: 8px;">            
                    <input class="form-control" type="text"  minlength="35"  name="foreignTaxMapping"  [(ngModel)]="item.foreignTaxMapping" autocomplete="off"   >
              </td>
              <td   style="padding: 8px;">
                <button type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="UpdateTax(item)"  [disabled]="DisabledTUpDATE(item)">Update</button>
              </td>

            </tr>
           
          </tbody>
        </table>
</div>
</mat-tab> -->
</mat-tab-group>
</div>
                      </div>
                      <div *ngIf="carrierAction==='gstDetail'" class="modal-content " >
                          <div class="modal-header title" *ngIf="showGstPopup">
                            <h4 class="modal-title">Add GST</h4>
                                <!-- url="https://www.primefaces.org/cdn/api/upload.php"  -->

                                <button *ngIf="!selectedFile" type="button" mat-raised-button (click)="fileInput.click()">Select File</button>
                                <button *ngIf="selectedFile" type="button" mat-raised-button (click)="fileInput.click()">{{selectedFile?.name}}</button>

                                <input hidden  accept=".xlsx, .xls" (change)="onFileSelected($event)" #fileInput type="file"> 
                                <button   class="btn btn-outline-success c-width-100px shadow " (click)="uploadFile()"  [disabled]="!fileSelected">Bulk Upload</button>

                           
     
                            <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
                            </div>
                            <div class="modal-body">
                            <div class="col-md-12 mt-3 " *ngIf="showGstPopup">
                              <div class="col-md-12 d-flex justify-content-center" >
                              <div class="col-md-12 row " >
                                  <div class=" col-md-12 " >
                                      <form    autocomplete="off"  class=" row" >
                                       
                                        <mat-form-field class="col-md-12 example-chip-list" appearance="outline">
                                          <mat-chip-grid #chipGrid aria-label="State selection">
                                            <!-- <mat-chip-row *ngFor="let messagType of selectedStateTypes" class="inside-text pt-0 pb-0 pl-0 pr-0" (removed)="remove(messagType)">
                                              {{messagType}}
                                              <button matChipRemove [attr.aria-label]="'remove ' + messagType" >
                                                <mat-icon>cancel</mat-icon>
                                              </button>
                                            </mat-chip-row> -->
                                          </mat-chip-grid>
                                          <input placeholder="Search State..." #messageTypeInput [formControl]="messageTypeCtrl" [matChipInputFor]="chipGrid" [matAutocomplete]="auto" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="add($event)" class="inside-text"/>
                                          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                                            <mat-option *ngFor="let gstType of filteredMessageTypes | async" [value]="gstType">
                                              {{gstType}}
                                            </mat-option>
                                          </mat-autocomplete>
                                        </mat-form-field> 
                                        <div class="col-md-12 pt-2" style="overflow: auto;max-height:40vh ;">
                                        <mat-form-field *ngFor="let item of GstData;let i=index" class="col-md-12 " appearance="outline" >
                                        <mat-label>{{item.state}}</mat-label>
                                        <div class="input-with-icon col-md-12"> 
                                          <input matInput type="text"  (input)="validateGST(item)"  [(ngModel)]="item.gstNumber" maxlength="15" name="{{'gstNumber'+(i+1)}}"   >
                                          <mat-icon (click)="remove(item.state)">cancel</mat-icon>
                                        </div>
                                        <small *ngIf="!item.isValid" class="error-message" style="color: red;">Please enter a correct GST Number</small>

                                        </mat-form-field>
                                      </div>
                                          
                                           
                                        
                                      
                                              </form>
                                  </div>
                                  </div>
                                  </div>                                      
                            </div>
                              <div class="modal-footer">
                                <div class="form-group form-inline ">
                                  <label for="gstlabel" class="col-md-5 col-form-label control-label"> </label>
                                </div>   
                                <button   class="btn btn-outline-success c-width-100px shadow " (click)="AddGST()"  [disabled]="!disableGst()">Save</button>
                                <button type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                              </div>
                            </div>
                            </div>
                    </div>
                </div>
                